export default __webpack_public_path__ + "ee1743afebb08a56d4b3b8f1af36eeaf.png";